import { combineReducers } from 'redux'
import _ from 'lodash'

import {
  FETCH_ITEMS,
  FETCH_ITEMS_SUCCESS,
  FETCH_ITEMS_FAIL,
//  FETCH_STATS_SUCCESS,
//  FETCH_SINGLE_STATS_SUCCESS,
  FETCH_ITEM,
  FETCH_ITEM_SUCCESS,
  FETCH_ITEM_FAIL,
  EXPAND,
  COLLAPSE,
  SET_EXPANDED,
  SAVE_FILTER,
  FETCH_FILTER,
  FETCH_FILTER_SUCCESS,
  SAVE_SORT,
  FETCH_SORT,
  FETCH_SORT_SUCCESS,
  DELETE_SINGLE_ITEM_SUCCESS,
  SET_SORT,
  NEXT_PAGE,
  CREATE_EMPTY_PLAYLIST,
  CREATE_EMPTY_PLAYLIST_FAIL,
  CREATE_EMPTY_PLAYLIST_SUCCESS,
  CREATE_PLAYLIST_FROM_ASSET,
  CREATE_PLAYLIST_FROM_ASSET_SUCCESS,
} from 'react-redux/actions/playlist'

import { RESET } from 'react-redux/actions/app'


const initialListState = {
  items: {},
  // view
  list: [],

  created: {},
  createdList: [],

  fetchingList: false,
  filter: {
    initialized: false,
    expression: "",
    fetching: false
  },
  pagination: {
    reachedEnd: false,
    page: 0,
    maxResults: 3,
  },
  query: {
    filter: null,
    page: null,
    sort_by_field: null,
    reverse_order: null,
    max_results: null
  },
  pendingQuery: null,
  sort: {
    initialized: false,
    field: "name",
    fetching: false,
    reverse: {
      name: false,
      timeCreated: false,
      timeModified: false
    }
  },

  expanded: {}
}

export const list = (state = initialListState, action) => {
  switch (action.type) {
      case RESET: {
        return _.cloneDeep(initialListState)
      }
      case FETCH_ITEMS: {
        const {filter, page, sort_by_field, reverse_order, max_results} = action.payload
        const pendingQuery =  {
          filter,
          page,
          sort_by_field,
          reverse_order,
          max_results
        }
        return Object.assign(
          {},
          state,
          {
            pendingQuery,
            fetchingList: true
          }
        )
      }
      case FETCH_ITEMS_SUCCESS: {
        const {query, pendingQuery, pagination} = state
        let items = Object.assign({}, state.items)
        let list = []
        action.payload.forEach((item)=>{
          const uid = item.id
          items[uid] = Object.assign({}, item.data, item.stats)
          list.push(uid)
        })
        const reachedEnd = (list.length < state.pendingQuery.max_results-1)
        const clear = query.filter !== pendingQuery.filter
          || query.sort_by_field !== pendingQuery.sort_by_field
          || query.reverse_order !== pendingQuery.reverse_order
        list = clear ? list: state.list.concat(list)
        let i = 0
        let createdList = [].concat(state.createdList)
        while (i<createdList.length) {
          const tid = createdList[i]
          if (list.indexOf(state.created[tid].uid) != -1) createdList.splice(i,1)
          else i++
        }
        return Object.assign(
          {},
          state,
          {
            items,
            query: Object.assign({}, pendingQuery),
            pendingQuery: null,
            list,
            createdList,
            pagination: Object.assign(
              {},
              pagination,
              {
                reachedEnd,
                page: pendingQuery.page
              }
            ),
            fetchingList: false
          }
        )
      }
      case FETCH_ITEMS_FAIL: {
        const { pagination, pendingQuery } = state
        return Object.assign(
          {},
          state,
          {
            list: [],
            query: Object.assign({}, pendingQuery),
            pendingQuery: null,
            fetchingList: false,
            pagination: Object.assign(
              {},
              pagination,
              {
                reachedEnd: true,
                page: 0
              }
            ),
          }
        )
      }
      case DELETE_SINGLE_ITEM_SUCCESS: {
        const items = Object.assign({}, state.items)
        if (items[action.context.payload.uid]) delete items[action.context.payload.uid]
        const list = _.without(state.list, action.context.payload.uid)
        const created = Object.assign({}, state.created)
        let tid
        for (tid in created) {
          if (created[tid].uid === action.context.payload.uid) break
        }
        delete created[tid]
        const createdList = _.without(state.createdList, tid)
        return Object.assign({}, state, {items, list, created, createdList})
      }
      case NEXT_PAGE: {
        if (state.reachedEnd || state.fetchingList) return state
        let pagination = Object.assign({}, state.pagination)
        pagination.page++
        return Object.assign({}, state, {pagination})
      }
      case FETCH_ITEM: {
        return state
      }
      case FETCH_ITEM_SUCCESS: {
        let items = _.merge({}, state.items)
        items[action.context.payload.uid] =  action.payload
        return Object.assign({}, state, {items})
      }
      case FETCH_ITEM_FAIL: {
        return state
      }
      case CREATE_EMPTY_PLAYLIST: {
        const { transactionId, payload } = action
        const {  name } = payload
        const created = Object.assign({}, state.created)
        created[transactionId] = {  name, completed: false }
        const createdList = [].concat(state.createdList)
        createdList.unshift(transactionId)
        return Object.assign(
          {},
          state,
          { created, createdList }
        )
      }
      case CREATE_EMPTY_PLAYLIST_SUCCESS: {
        const { transactionId, payload } = action
        const created = _.cloneDeep(state.created)
        created[transactionId].uid = payload.id
        created[transactionId].completed = true
        return Object.assign(
          {},
          state,
          { created }
        )
      }

      case CREATE_PLAYLIST_FROM_ASSET: {
        const { transactionId, payload } = action
        const {  name } = payload
        const created = Object.assign({}, state.created)
        created[transactionId] = {  name, completed: false }
        const createdList = [].concat(state.createdList)
        createdList.unshift(transactionId)
        return Object.assign(
          {},
          state,
          { created, createdList }
        )
      }
      case CREATE_PLAYLIST_FROM_ASSET_SUCCESS: {
        const { transactionId, payload } = action
        const created = _.cloneDeep(state.created)
        created[transactionId].uid = payload.id
        created[transactionId].completed = true
        return Object.assign(
          {},
          state,
          { created }
        )
      }
      case SAVE_FILTER: {
        const filter = Object.assign(
          {},
          state.filter,
          { expression: action.payload}
        )
        return Object.assign({}, state, { filter } )
      }
      case FETCH_FILTER: {
        const filter = Object.assign(
          {},
          state.filter,
          { fetching: true }
        )
        return Object.assign({}, state, { filter })
      }
      case FETCH_FILTER_SUCCESS: {
        const filter = Object.assign(
          {},
          state.filter,
          {
            expression: action.payload || "",
            fetching: false,
            initialized: true
          }
        )
        return Object.assign(
          {},
          state,
          {
            filter
          }
        )
      }
      case SAVE_SORT: {
        const {field, reverse} = action.payload
        const sort = Object.assign(
          {},
          state.sort,
          { field, reverse }
        )
        return Object.assign({}, state, { sort } )
      }
      case FETCH_SORT: {
        const sort = Object.assign(
          {},
          state.sort,
          { fetching: true }
        )
        return Object.assign({}, state, { sort })
      }
      case FETCH_SORT_SUCCESS: {
        let sort = Object.assign(
          {},
          state.sort,
          {
            fetching: false,
            initialized: true
          }
        )
        if (action.payload && action.payload.field)
          sort.field = action.payload.field
        if (action.payload && action.payload.reverse)
          sort.reverse = action.payload.reverse
        return Object.assign(
          {},
          state,
          { sort }
        )
      }
      case EXPAND: {
        let expanded = _.clone(state.expanded)
        expanded[action.uid] = true
        return Object.assign({}, state, { expanded })
      }
      case COLLAPSE: {
        let expanded = _.clone(state.expanded)
        delete expanded[action.uid]
        return Object.assign({}, state, { expanded })
      }
      case SET_EXPANDED: {
        return Object.assign({}, state, { expanded: action.expanded })
      }
      default:
        return state
  }
}

export default combineReducers({
  list
})



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/playlist.js